import axios from 'axios';
const url = `${process.env.REACT_APP_BACKEND_URL}/post`;

export const fetchPosts = async (clubId) =>
  (await axios.get(`${url}/list`, { params:{ clubId }, withCredentials:true })).data;

export const createPost = async (clubId, text) =>
  (await axios.post(`${url}/create`, { clubId, text }, { withCredentials:true })).data;